import { FC, useEffect } from 'react';
import { useParams } from 'react-router';
import { useAppDispatch } from '@services/hooks/helperHooks';
import { consumerActions } from '@store/consumer';
import { Chat } from '@components/consumer/support';

const ConsumerTicketPage: FC = () => {

    const dispatch = useAppDispatch();

    const { id } = useParams<{ id?: string }>();
    //const loading = useSelector((state: ReduxStore) => state.consumer.support.messages.loading);
    //const ticket = useTopic(id);

    useEffect(() => {
        if (!id) return;

        dispatch(consumerActions.support.loadTopic(id));
        dispatch(consumerActions.support.loadMessages(id));

    }, [dispatch, id]);

    return (
        <Chat />
    )
}

export default ConsumerTicketPage;